// extracted by mini-css-extract-plugin
module.exports = {"typoMega":"l_C","typoLarge":"l_D","typoBig":"l_F","typoPlus":"l_G","typoNormal":"l_H"};